import React from "react";
import { PageHeader } from "@/components/kit";
import { TeamsPanel } from "@/pages/Teams";

export default function TeamsPage() {
  return (
    <div>
      <PageHeader title="Teams" summary="Which teams have taken AI on board, and who is falling behind." testid="teams-page-header" />
      <TeamsPanel />
    </div>
  );
}
